<template>
    <div>
        <div class="colorNav">
            <div class="divn1">
                <img class="mt-0 ml-5" src="../img/logo Grupo horizon blanco_Mesa de trabaj.webp" height="80%">
            </div>

        </div>
        <b-overlay :show="show" variant="white" rounded="sm">
            <div class="div1">
                <div class="div2 mt-2">
                    <div class="div3">
                        <div class="d-flex align-items-center flex-column">
                            <img class="mt-0 d-flex " data-aos="zoom-in" data-aos-duration="2000"
                                src="../img/logo-horizontal.png" height="100rem">
                            <br>
                            <span class="etiqueta1 mt-2"> Inicio de Sesión</span>
                        </div>
                        <div class="div4 mt-5 " >
                            <b-input type="text" class="mb-5 mt-2 textoLogin" placeholder="Usuario" style="width: 92%;"
                                v-model="usuarios.Usuario"></b-input>
                            <div class="d-flex align-items-center ">
                                <b-input v-if="showPassword" type="text" class="mb-5 textoLogin" style="width: 92%;"
                                    placeholder="Contraseña" v-model="usuarios.Password">
                                </b-input>
                                <b-input v-else type="password" class="mb-5 textoLogin" placeholder="Contraseña" style="width: 92%;"
                                    v-model="usuarios.Password">
                                </b-input>
                                <button class="btn-eye"  @click="toggleShow">
                                    <i class="fas"
                                        :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
                                </button>
                            </div>
                        </div>

                        <button :disabled="show" class="botonesLogin mt-2 mb-4" @click="sbLogin">Iniciar Sesión</button>
                        <br>
                        <b-spinner v-if="btnCargando" style="width: 5rem; height: 5rem;" label="Large Spinner"
                            variant="primary"></b-spinner>

                    </div>

                </div>
            </div>
        </b-overlay>

    </div>
</template>

<script>
import servicioLogin from '@/services/servicioLogin'

export default {
    data() {
        return {
            usuarios: {
                Usuario: '',
                Password: ''
            },
            datos: {
                Campo: '',
                Serie: ''
            },
            btnCargando: false,
            show: false,
            showPassword: false
        }
    },
    methods:
    {
        async sbLogin() {
            // this.btnCargando = true
            this.show = true
            const result = await servicioLogin.consultarUsuario(this.usuarios.Usuario, this.usuarios.Password);
            if (result.value) {
                if (result.data.length > 0) {
                    localStorage.idCliente = result.data[0].clienteID
                    localStorage.nombreCliente = result.data[0].nombre
                    localStorage.empresa = result.data[0].empresa

                    if (result.data[0].formaCompraID == 1) {
                        this.$router.push({ name: "menuCredito" });
                    }
                    else {
                        if (result.data[0].empresa == 1) {
                            this.$msg.info("Opcion no disponible para clientes de DIAMOND GAS ,Muy pronto podrás comprar saldo prepago rápido y fácil desde esta página !")
                        }
                        if (result.data[0].empresa == 0)
                        {
                            this.$msg.info("Opcion no disponible. Muy pronto podrás comprar saldo prepago rápido y fácil desde esta página !")
                        }
                        // else { this.$router.push({ name: "menuDebito" }); }
                    }
                }
                else {
                    this.$msg.info("Usuario no existente")
                }

            }
            else {
                this.$msg.info(result.message)

            }
            // this.btnCargando = false
            this.show = false
        },
        toggleShow() {
            this.showPassword = !this.showPassword;
        },
    }
}
</script>
<style>
.textoLogin {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom-style: ridge;
    font-size: 18px;
    width: 100%;
}

.etiqueta1 {
    font-size: 1.8rem;
    color: #09A9EA;
    font-weight: bold;
}

.div1 {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%;
}



.div2 {
    display: flex;
    background-color: white;
    justify-content: center;
    width: 100%;
    padding-left: 5%;
    padding-right: 5%;
    align-content: center;
}

.div3 {
    background-color: white;
    height: 400px;
    padding-left: 5%;
    padding-right: 5%;
    align-content: center;
    align-items: center;
    margin-top: 2.5rem;
    width: 100%;
}

.div4 {
    display: grid;
    width: 100%;

}

.btn-eye {
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(150, 150, 150);
  font-size: 18px;
}

.btn-eye:hover {
    background-color: #e8e8e9;
    border-radius: 10px;
}

.botonesLogin {
    width: 70%;
    height: 2.5rem;
    border-radius: 15px;
    align-items: center;
    font-size: 20px;
    background-color: #09A9EA;
    border: 1px solid #09A9EA;
    font-weight: bold;
    font-family: 'Montserrat', sans-serif;
    color: white;


    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
}

.botonesLogin:hover {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.colorNav {
    background-image: -webkit-gradient(linear, left top, left bottom, from(#09A9EA), to(#0073BC));
    background-image: linear-gradient(to bottom, #09A9EA, #0073BC);
}

.divn1 {
    /*     background-color:rgb(39, 157, 204); */
    color: white;
    font-size: large;
    width: 30%;
    height: 3.6rem;
    display: flex;
}



@media screen and (min-width:780px) {
    .div3 {
        background-color: white;
        width: 65%;
        height: 500px;
        margin-top: 4rem;
    }
}

@media screen and (min-width:1024px) {
    .div3 {
        background-color: white;
        width: 45%;
        height: 500px;
        margin-top: 4rem;
    }
}
</style>